import React from 'react';
import { Save } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

export const SEOSettingsTab = () => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardHeader>
        <CardTitle className="text-lg">SEO Settings</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Meta Title</Label>
          <Input
            defaultValue="PropFirmHouse - Compare Top Prop Trading Firms 2026"
            className="mt-2"
            maxLength={60}
          />
          <p className="text-xs text-slate-500 mt-1">60 characters max</p>
        </div>
        <div>
          <Label>Meta Description</Label>
          <Textarea
            defaultValue="Compare reviews, ratings, and features of the best prop trading firms. Find verified payouts and honest trader reviews."
            className="mt-2"
            rows={3}
            maxLength={160}
          />
          <p className="text-xs text-slate-500 mt-1">160 characters max</p>
        </div>
        <div>
          <Label>Google Analytics ID</Label>
          <Input placeholder="G-XXXXXXXXXX" className="mt-2" />
        </div>
        
        <div className="pt-4 space-y-4 border-t">
          <h3 className="font-semibold text-slate-900">Custom Scripts</h3>
          <p className="text-sm text-slate-600">Add custom scripts for Google Tag Manager, Facebook Pixel, etc.</p>
          
          <div>
            <Label>Header Scripts</Label>
            <p className="text-xs text-slate-500 mb-2">Scripts added here will be inserted in the &lt;head&gt; section</p>
            <Textarea
              placeholder="<script>&#10;  // Google Tag Manager, etc.&#10;</script>"
              rows={5}
              className="mt-2 font-mono text-xs"
            />
          </div>
          
          <div>
            <Label>Body Scripts (Top)</Label>
            <p className="text-xs text-slate-500 mb-2">Scripts added here will be inserted at the top of &lt;body&gt;</p>
            <Textarea
              placeholder="<script>&#10;  // Body scripts&#10;</script>"
              rows={5}
              className="mt-2 font-mono text-xs"
            />
          </div>
          
          <div>
            <Label>Footer Scripts</Label>
            <p className="text-xs text-slate-500 mb-2">Scripts added here will be inserted before closing &lt;/body&gt; tag</p>
            <Textarea
              placeholder="<script>&#10;  // Footer scripts, analytics&#10;</script>"
              rows={5}
              className="mt-2 font-mono text-xs"
            />
          </div>
        </div>
        
        <Button onClick={() => toast.success('SEO settings saved')}>
          <Save className="h-4 w-4 mr-2" />
          Save Changes
        </Button>
      </CardContent>
    </Card>
  );
};